module.exports = __webpack_public_path__ + "img/EKIS.8366bbaa.svg";